var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-footer"},[_c('el-main',{staticClass:"main"},[_c('div',{staticClass:"item"},[_vm._v("sunbengu-博客 | 鄂ICP备2021010277号")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }